export default __webpack_public_path__ + "static/media/md8-cybersecurity-data-architecture.3a37e826.svg";